import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-project-layout',
  templateUrl: './project-layout.component.html',
  styleUrls: ['./project-layout.component.scss']
})
export class ProjectLayoutComponent implements OnInit {

  selected: boolean = false;
  activeRoute = '';
  leadStatus: any;
  constructor(public router: Router) { 
    //debugger
    this.activeRoute = this.router.url;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd)=> {
      this.activeRoute = event.url;
    })
    //debugger
    this.leadStatus = sessionStorage.getItem('leadStatus');
  
    // Redirect to /activated if leadStatus is 'activated' and current URL is NOT /activated
    // if (this.leadStatus === 'Activated' && this.activeRoute !== '/activated') {
    //   this.router.navigate(['/activated']);
    // }
  }

  ngOnInit(): void {
 
  }
  menuhide1(){
    this.selected =!this.selected;
  }
}
